import CodeViewModule from './CodeViewModule.vue';
import CodeViewPage from './views/CodeViewPage.vue';
export const codeViewRoutes = [
  {
    path: '/codeView/:workspaceId',
    name: 'CodeView',
    component: CodeViewModule,
    children: [
      {
        path: '',
        name: 'CodeView.CodeViewPage',
        component: CodeViewPage
      }
    ]
  }
];
